import React, { useEffect } from "react";
import { Loader } from "@mantine/core"
import { getAuth0Token } from '../api.js'
import { useAccountStore } from "../zustand/account";

const Auth0CallbackPage = () => {

  useAccountStore();

  let params = new URLSearchParams(document.location.search);

  const code = params.get("code");


  useEffect(() => {
    if (!code) {
      // optional: redirect to login or error page
      // window.location.replace('http://localhost:3000/login');
      return;
    }

    getAuth0Token({ code, redirect_uri: 'https://mbxr.io/logging-in' })
      // getAuth0Token({ code, redirect_uri: 'http://localhost:3000/logging-in' })
      .then((res) => localStorage.setItem('user', res.token))
      .then(() => window.location.replace('https://mbxr.io/projects'))
      // .then(() => window.location.replace('http://localhost:3000/projects'))
      .catch((err) => {
        console.error("Auth0 token exchange failed", err);
        // optional: redirect to an error page
      });
  }, [code]);

  // if (error) {
  //   return <div>Oops... {error.message}</div>;
  // }
  return <>
    <div style={{ position: "absolute", left: "50%", top: "50%", width: "100%", height: "100%" }}><Loader color="black" /></div>

  </>


};


export default Auth0CallbackPage;
